import React, { createContext, useState } from "react";
import { useLazyQuery, gql } from "@apollo/client";
import { remove } from "aws-amplify/storage";

export const GlobalContext = createContext();

const GET_REQUEST_DETAILS = gql`
  query GetDetails($requestUid: uuid!) {
    request_by_pk(id: $requestUid) {
      id
      actual_price
      construction_methodology
      description
      due_date
      estimate_price
      methodology_building
      methodology_outputs
      model_development
      methodology_phase
      model_equipment
      model_phase
      model_type
      model_usage
      status
      title
      update_date
      work_streams
      download_link
      jira_url
      output_format
      required_software
      budget
    }
  }
`;
const GET_REQUEST_LIST = gql`
  query Query($technician_id: uuid!) {
    get_request_list_by_technician_id(
      args: { input_technician_id: $technician_id }
    ) {
      update_date
      title
      technician_name
      status
      id
      due_date
      project_id
      technician_unread_message_count
      user_unread_message_count
      project_name
    }
  }
`;
const GET_ALL_REQUEST_LIST = gql`
  query Query {
    get_all_requests_with_technician_names {
      due_date
      id
      project_id
      project_name
      status
      technician_name
      technician_unread_message_count
      title
      update_date
      user_id
      user_unread_message_count
    }
  }
`;

export default function GlobalContextProvider(props) {
  const [isListRefetching, setIsListRefetching] = useState(false);
  const [isDetailRefetching, setIsDetailRefetching] = useState(false);
  const [selectProjectId, setSelectProjectId] = useState("");
  const [isAllRequestListRefetching, setIsAllRequestListRefetching] =
    useState(false);
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [isManager, setIsManager] = useState(false);
  const [menuNavigationPage, setMenuNavigationPage] = useState("Project");
  const [tempMessageFile, setTempMessageFile] = useState(null);
  const [
    fetchRequestDetail,
    {
      loading: RequestDetailLoading,
      error,
      data: RequestDetailData,
      refetch: refetchRequestDetail,
    },
  ] = useLazyQuery(GET_REQUEST_DETAILS);

  if (error) {
    console.log(error.message);
  }

  const [
    fetchRequestList,
    {
      loading: RequestListLoading,
      error: RequestListError,
      data: RequestListData,
      refetch: refetchRequestList,
    },
  ] = useLazyQuery(GET_REQUEST_LIST);
  if (RequestListError) {
    console.log(RequestListError.message);
  }
  const [
    fetchAllRequestList,
    {
      loading: AllRequestListLoading,
      error: AllRequestListError,
      data: AllRequestListData,
      refetch: refetchAllRequestList,
    },
  ] = useLazyQuery(GET_ALL_REQUEST_LIST);
  if (AllRequestListError) {
    console.log(AllRequestListError.message);
  }

  //These are used for setting the right loading value while refetching data, otherwise user hard to know if the data is refetching

  const handleRefetchRequestDetail = async () => {
    await refetchRequestDetail();
    setIsDetailRefetching(false);
  };

  const handleRefetchRequestList = async () => {
    await refetchRequestList();
    setIsListRefetching(false);
  };

  const handleRefetchAllRequestList = async (technicianId) => {
    await refetchAllRequestList({ technician_id: technicianId });
    setIsAllRequestListRefetching(false);
  };

  // Delete temp message file
  const deleteMessageTempUpload = async () => {
    if (tempMessageFile) {
      try {
        console.log("Remove ", tempMessageFile);
        remove({
          path: tempMessageFile,
        });
      } catch (error) {
        console.log("Error ", error);
      }
      setTempMessageFile(null);
    }
  };

  return (
    <GlobalContext.Provider
      value={{
        fetchRequestDetail,
        RequestDetailLoading: RequestDetailLoading || isDetailRefetching,
        RequestDetailData,
        handleRefetchRequestDetail,
        setIsDetailRefetching,
        fetchRequestList,
        RequestListLoading: RequestListLoading || isListRefetching,
        RequestListData,
        handleRefetchRequestList,
        setIsListRefetching,
        fetchAllRequestList,
        AllRequestListLoading:
          AllRequestListLoading || isAllRequestListRefetching,
        AllRequestListData,
        handleRefetchAllRequestList,
        setUserId,
        userId,
        setUserName,
        userName,
        menuNavigationPage,
        setMenuNavigationPage,
        isManager,
        setIsManager,
        selectProjectId,
        setSelectProjectId,

        setTempMessageFile,
        deleteMessageTempUpload,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
}
